import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import App from './App';
import UserProvider from "./context/UserProvider";
import VerificarUsuario from './componentes/VerificarUsuario';

const Categoria = lazy(() => import('./views/Categoria'));
const DashBoard = lazy(() => import('./views/DashBoard'));
const Inicio = lazy(() => import('./views/Inicio'));
const NotFound = lazy(() => import('./views/NotFound'));
const Producto = lazy(() => import('./views/Producto'));
const ReporteVenta = lazy(() => import('./views/ReporteVenta'));
const Usuario = lazy(() => import('./views/Usuario'));
const Login = lazy(() => import('./views/Login'));
const PoliticaPrivacidad = lazy(() => import('./views/PoliticaPrivacidad'));
const CondicionesServicio = lazy(() => import('./views/CondicionesServicio'));

const Citas = lazy(() => import("./views/Citas/Citas"));
const HabilitarCirugias = lazy(() => import("./views/Citas/HabilitarCirugias"));
const ConfirmacionCita = lazy(() => import("./views/Citas/ConfirmacionCita"));
const Especialistas = lazy(() => import("./views/Citas/Especialistas"));
const ReporteCitas = lazy(() => import("./views/Citas/ReporteCitas"));
const Coordinador = lazy(() => import("./views/Citas/Coordinador"));
const Empresas = lazy(() => import("./views/Administracion/Empresas"));
const RPD = lazy(() => import("./views/Administracion/Reporteria"));
const CorreoConfig = lazy(() => import("./views/Administracion/CorreoConfig"));

const CPacientes = lazy(() => import("./views/Consultorio/CPacientes"));
const Nutricion = lazy(() => import("./views/Consultorio/Nutricion/Nutricion"));
const Ginecologo = lazy(() => import("./views/Consultorio/Ginecologo/Ginecologo"));
const ReportesGinecologo = lazy(() => import("./views/Consultorio/Ginecologo/ImpresionReporteAtendido"));
const ImpresionReceta = lazy(() => import("./views/Consultorio/Gastro/ImpresionReceta"));
const Ginecologia = lazy(() => import("./views/Consultorio/Ginecologia/Ginecologia"));
const Reclamaciones = lazy(() => import("./views/Consultorio/Ginecologia/ReclamacionesG"));
const CVentas = lazy(() => import("./views/Consultorio/CVenta"));
const Seguros = lazy(() => import("./views/Consultorio/Seguros"));
const Doctores = lazy(() => import("./views/Consultorio/Doctores"));
const Medicamentos = lazy(() => import("./views/Consultorio/Medicamentos"));
const Masaje = lazy(() => import("./views/Consultorio/Masaje"));
const CImpresionFactura = lazy(() => import('./views/Consultorio/CImpresionFactura'));
const HistorialVentaC = lazy(() => import('./views/Consultorio/HistorialVentas'));
const ReportesC = lazy(() => import('./views/Consultorio/Reportes/Reportes'));
const Toxico = lazy(() => import('./views/Consultorio/Toxico'));
const Descarga = lazy(() => import('./views/Interativo/Descargas'));

const Clientes = lazy(() => import("./views/CXC/Cliente"));
const RegistroCXC = lazy(() => import("./views/CXC/RegistroCXC"));
const InformesCXC = lazy(() => import('./views/CXC/Informes/InformesCXC'));
const ImpresionCXC = lazy(() => import('./views/CXC/Informes/ImpresionCXC'));

const RegistroCXP = lazy(() => import("./views/cxp/RegistroCXP"));
const InformesCXP = lazy(() => import('./views/cxp/Informes/InformesInCXP'));
const ImpresionCXP = lazy(() => import('./views/cxp/Informes/ImpresionCXP'));

const Vip = lazy(() => import('./views/Administracion/VIP'));

const Venta = lazy(() => import('./views/Ventas/Venta'));
const HistorialVentaT = lazy(() => import('./views/Ventas/HistorialVentas'));
const VentaCaja = lazy(() => import('./views/Ventas/VentaCaja'));
const Articulos1 = lazy(() => import('./views/Ventas/Articulos'));
const Suplidor = lazy(() => import('./views/Ventas/Suplidor'));
const MovimientoAlmacen = lazy(() => import('./views/Ventas/MovimientosAlmacen'));
const Almacen = lazy(() => import('./views/Ventas/Almacen'));
const ImpresionFactura = lazy(() => import('./views/Ventas/ImpresionFactura'));
const ImpresionCotizacion = lazy(() => import('./views/Ventas/ImpresionCotizacion'));
const Clientes1 = lazy(() => import('./views/Ventas/Clientes'));
const SecuenciaNumerica = lazy(() => import('./views/Administracion/SecuenciaNumerica'));

const InformesInventario = lazy(() => import('./views/Inventario/Informes/InformesInventario'));
const ImpresionInventario = lazy(() => import('./views/Inventario/Informes/ImpresionInventario'));

const ImpresionVentas = lazy(() => import('./views/Ventas/Informes/ImpresionVentas'));
const InformesVentas = lazy(() => import('./views/Ventas/Informes/InformesVentas'));
const CuadreCajaPV = lazy(() => import('./views/Ventas/Informes/CuadreCajaPV'));
const CuadreCajaNCF = lazy(() => import('./views/Ventas/Informes/CuadreCajaNCF'));

const RouteFallback = () => (
    <div style={{ padding: "2rem", textAlign: "center" }}>
        Cargando...
    </div>
);

const root = ReactDOM.createRoot(document.getElementById('wrapper'));

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(reg => console.log('[SW] Registrado', reg))
            .catch(err => console.error('[SW] Error', err));
    });
}

root.render(
    <BrowserRouter>
        <UserProvider>
            <Suspense fallback={<RouteFallback />}>
                <Routes>
                    <Route path='/ImpresionFactura/:Pedido' element={<ImpresionFactura />} />
                    <Route path='/ImpresionInventario/:Pedido' element={<ImpresionInventario />} />
                    <Route path='/ImpresionVentas/:Pedido' element={<ImpresionVentas />} />
                    <Route path='/ImpresionCXC/:Pedido' element={<ImpresionCXC />} />
                    <Route path='/ImpresionCXP/:Pedido' element={<ImpresionCXP />} />
                    <Route path='/descarga/:Pedido/:p1/:p2/:p3' element={<Descarga />} />

                    <Route path='/CuadreCajaPV' element={<CuadreCajaPV />} />
                    <Route path='/CuadreCajaNCF' element={<CuadreCajaNCF />} />
                    <Route path='/ImpresionCotizacion/:Pedido' element={<ImpresionCotizacion />} />
                    <Route path='/CImpresionFactura/:Pedido' element={<CImpresionFactura />} />
                    <Route path='/ImpresionReceta/:Pedido/:Reporte/:Modulo' element={<ImpresionReceta />} />
                    <Route index path='/ConfirmacionCita/:ID/:Tel' element={<ConfirmacionCita />} />

                    <Route index path='/Login' element={<Login />} />
                    <Route index path='/PoliticaPrivacidad' element={<PoliticaPrivacidad />} />
                    <Route index path='/CondicionesServicio' element={<CondicionesServicio />} />

                    <Route path='/' element={<App />}>
                        <Route index element={<Inicio />} />
                        <Route path='dashboard' element={<VerificarUsuario><DashBoard /></VerificarUsuario>} />
                        <Route path='producto' element={<VerificarUsuario><Producto /></VerificarUsuario>} />
                        <Route path='categoria' element={<VerificarUsuario><Categoria /></VerificarUsuario>} />
                        <Route path='ventacaja' element={<VerificarUsuario><VentaCaja /></VerificarUsuario>} />
                        <Route path='reporteventa' element={<VerificarUsuario><ReporteVenta /></VerificarUsuario>} />

                        <Route path='citas' element={<VerificarUsuario Rol="1" SubRol="1"><Citas /></VerificarUsuario>} />
                        <Route path='CitasMasaje' element={<VerificarUsuario Rol="1" SubRol="5"><Citas soloMasaje /></VerificarUsuario>} />
                        <Route path='especialistas' element={<VerificarUsuario><Especialistas /></VerificarUsuario>} />
                        <Route path='reportecitas' element={<VerificarUsuario Rol="1" SubRol="2"><ReporteCitas /></VerificarUsuario>} />
                        <Route path='HabilitarCirugias' element={<VerificarUsuario Rol="1" SubRol="3"><HabilitarCirugias /></VerificarUsuario>} />
                        <Route path='coordinador' element={<VerificarUsuario Rol="1" SubRol="4"><Coordinador /></VerificarUsuario>} />

                        <Route path='Clientes' element={<VerificarUsuario><Clientes /></VerificarUsuario>} />

                        <Route path='Vip' element={<VerificarUsuario><Vip /></VerificarUsuario>} />

                        <Route path='venta' element={<VerificarUsuario Rol="2" SubRol="1"><Venta /></VerificarUsuario>} />
                        <Route path='HistorialVenta' element={<VerificarUsuario Rol="2" SubRol="2"><HistorialVentaT /></VerificarUsuario>} />
                        <Route path='InformesVentas' element={<VerificarUsuario Rol="2" SubRol="3"><InformesVentas /></VerificarUsuario>} />

                        <Route path='Articulos1' element={<VerificarUsuario Rol="3" SubRol="1"><Articulos1 /></VerificarUsuario>} />
                        <Route path='MovimientoAlmacen' element={<VerificarUsuario Rol="3" SubRol="2"><MovimientoAlmacen /></VerificarUsuario>} />
                        <Route path='Almacen' element={<VerificarUsuario Rol="3" SubRol="3"><Almacen /></VerificarUsuario>} />
                        <Route path='InformesInventario' element={<VerificarUsuario Rol="3" SubRol="4"><InformesInventario /></VerificarUsuario>} />

                        <Route path='Clientes1' element={<VerificarUsuario Rol="4" SubRol="1"><Clientes1 /></VerificarUsuario>} />
                        <Route path='RegistroCXC' element={<VerificarUsuario Rol="4" SubRol="2"><RegistroCXC /></VerificarUsuario>} />
                        <Route path='InformesCXC' element={<VerificarUsuario Rol="4" SubRol="3"><InformesCXC /></VerificarUsuario>} />

                        <Route path='Suplidor' element={<VerificarUsuario Rol="5" SubRol="1"><Suplidor /></VerificarUsuario>} />
                        <Route path='RegistroCXP' element={<VerificarUsuario Rol="5" SubRol="2"><RegistroCXP /></VerificarUsuario>} />
                        <Route path='InformesCXP' element={<VerificarUsuario Rol="5" SubRol="3"><InformesCXP /></VerificarUsuario>} />

                        <Route path='CPacientes' element={<VerificarUsuario Rol="7" SubRol="3"><CPacientes /></VerificarUsuario>} />
                        <Route path='Masaje' element={<VerificarUsuario Rol="7" SubRol="11,3"><Masaje /></VerificarUsuario>} />
                        <Route path='Ginecologo' element={<VerificarUsuario Rol="7" SubRol="2"><Ginecologo /></VerificarUsuario>} />
                        <Route path='ReportesGinecologo' element={<VerificarUsuario Rol="7" SubRol="2"><ReportesGinecologo /></VerificarUsuario>} />
                        <Route path='Ginecologia' element={<VerificarUsuario><Ginecologia /></VerificarUsuario>} />
                        <Route path='Reclamaciones' element={<VerificarUsuario Rol="7" SubRol="3"><Reclamaciones /></VerificarUsuario>} />
                        <Route path='CVentas' element={<VerificarUsuario Rol="7" SubRol="3"><CVentas /></VerificarUsuario>} />
                        <Route path='HistorialVentaC' element={<VerificarUsuario Rol="7" SubRol="4"><HistorialVentaC /></VerificarUsuario>} />
                        <Route path='ReportesC' element={<VerificarUsuario Rol="7" SubRol="3"><ReportesC /></VerificarUsuario>} />
                        <Route path='Doctores' element={<VerificarUsuario Rol="7" SubRol="5"><Doctores /></VerificarUsuario>} />
                        <Route path='Seguros' element={<VerificarUsuario Rol="7" SubRol="6"><Seguros /></VerificarUsuario>} />
                        <Route path='Medicamentos' element={<VerificarUsuario Rol="7" SubRol="7"><Medicamentos /></VerificarUsuario>} />
                        <Route path='Toxico' element={<VerificarUsuario Rol="7" SubRol="8"><Toxico /></VerificarUsuario>} />
                        <Route path='Articulos1' element={<VerificarUsuario Rol="7" SubRol="8"><Articulos1 /></VerificarUsuario>} />
                        <Route path='Nutricion' element={<VerificarUsuario Rol="7" SubRol="9"><Nutricion /></VerificarUsuario>} />
                        <Route path='RPD' element={<VerificarUsuario><RPD /></VerificarUsuario>} />

                        <Route path='usuario' element={<VerificarUsuario Rol="8" SubRol="1"><Usuario /></VerificarUsuario>} />
                        <Route path='empresas' element={<VerificarUsuario Rol="8" SubRol="2"><Empresas /></VerificarUsuario>} />
                        <Route path='configcorreo' element={<VerificarUsuario Rol="8" SubRol="2"><CorreoConfig /></VerificarUsuario>} />
                        <Route path='secuencianumerica' element={<VerificarUsuario Rol="8" SubRol="3"><SecuenciaNumerica /></VerificarUsuario>} />
                    </Route>

                    <Route path='*' element={<NotFound />} />
                </Routes>
            </Suspense>
        </UserProvider>
    </BrowserRouter>
);
